module.exports = __webpack_public_path__ + "static/media/naturgy.3f8bdded.png";